import { Sparkles, Flower2, Hand } from "lucide-react";
import { FadeUp } from "@/components/Reveal";

const INFOGRAPHIC =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_134b3b07-bdc2-4f4a-bd99-c12f6d023f68/artifacts/nejwwvap_Gentle%20hands%20bodywork.png";

export default function FeaturedWombLifting() {
  return (
    <section
      className="bg-blush/40 py-24 lg:py-32"
      data-testid="featured-womb-lifting-section"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <FadeUp>
          <div className="flex items-center gap-4 text-xs font-semibold uppercase tracking-[0.3em] text-sienna">
            <span className="h-px w-10 bg-sienna/50" aria-hidden />
            <span>Ancestral bodywork · Coming soon</span>
          </div>
          <h2
            className="mt-6 max-w-4xl font-serif text-4xl font-light leading-tight text-espresso sm:text-5xl lg:text-6xl"
            data-testid="womb-lifting-title"
          >
            Traditional <span className="italic text-sienna">Womb Lifting</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-cocoa">
            An ancestral bodywork practice — slow, warming, therapeutic touch
            to the abdomen that encourages the womb back to her rightful place
            after birth, restoring flow, warmth and vitality.
          </p>
        </FadeUp>

        <FadeUp delay={0.15}>
          <div
            className="mt-14 overflow-hidden rounded-3xl border border-espresso/12 bg-ivory/70 backdrop-blur-sm"
            data-testid="womb-lifting-card"
          >
            <div className="grid grid-cols-1 items-stretch lg:grid-cols-12">
              <figure className="bg-cream lg:col-span-7">
                <img
                  src={INFOGRAPHIC}
                  alt="Gentle Womb Bodywork — a five-step visual guide: Warmth, Restorative, Support, Holding, Nurture."
                  className="h-full w-full object-contain"
                  data-testid="womb-lifting-infographic"
                />
              </figure>
              <div className="flex flex-col justify-center gap-6 p-10 lg:col-span-5 lg:p-14">
                <span
                  className="inline-flex w-fit items-center gap-2 rounded-full bg-sienna/15 px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.28em] text-sienna"
                  data-testid="womb-lifting-coming-soon"
                >
                  <Sparkles className="h-3.5 w-3.5" strokeWidth={1.5} />
                  Coming soon
                </span>
                <h3 className="font-serif text-3xl font-light leading-tight text-espresso sm:text-4xl">
                  Gentle Womb Bodywork
                </h3>
                <p className="font-serif text-base italic text-cocoa/80">
                  A five-step traditional practice — warmth, restoration,
                  support, holding, and nurture — inviting the womb softly
                  back home.
                </p>
                <ul className="space-y-4 border-t border-espresso/10 pt-6 text-[15px] leading-relaxed text-espresso/90">
                  <li className="flex gap-4">
                    <span className="font-serif text-sm italic text-sienna/80">01</span>
                    <span><span className="font-serif italic text-espresso">Warmth</span> — gentle contact, inviting connection to the womb space.</span>
                  </li>
                  <li className="flex gap-4">
                    <span className="font-serif text-sm italic text-sienna/80">02</span>
                    <span><span className="font-serif italic text-espresso">Restorative</span> — slow, steady hands that encourage soft opening.</span>
                  </li>
                  <li className="flex gap-4">
                    <span className="font-serif text-sm italic text-sienna/80">03</span>
                    <span><span className="font-serif italic text-espresso">Support</span> — tender lifting touch offered without hurry.</span>
                  </li>
                  <li className="flex gap-4">
                    <span className="font-serif text-sm italic text-sienna/80">04</span>
                    <span><span className="font-serif italic text-espresso">Holding</span> — a place of rest for the womb to settle.</span>
                  </li>
                  <li className="flex gap-4">
                    <span className="font-serif text-sm italic text-sienna/80">05</span>
                    <span><span className="font-serif italic text-espresso">Nurture</span> — warmth and closing touch that seal the work.</span>
                  </li>
                </ul>
                <div className="mt-2 flex items-start gap-3 border-t border-espresso/10 pt-6 text-sm text-cocoa/85">
                  <Flower2 className="mt-0.5 h-4 w-4 shrink-0 text-sienna" strokeWidth={1.5} />
                  <p>
                    Availability opens once training is complete — I'll share
                    the moment this care is ready to hold you.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
